var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66602 23.3333C7.04935 24.4033 9.12768 25.0283 11.4993 25C13.871 25.0283 15.9493 24.4033 17.3327 23.3333C18.716 22.2633 20.7943 21.6383 23.166 21.6667C25.5377 21.6383 27.616 22.2633 28.9993 23.3333M13.9994 5C13.4719 5.37862 13.0445 5.87995 12.7541 6.46071C12.4637 7.04146 12.3191 7.68417 12.3327 8.33333C12.3191 8.98249 12.4637 9.62521 12.7541 10.206C13.0445 10.7867 13.4719 11.288 13.9994 11.6667M20.666 5C20.1385 5.37862 19.7112 5.87995 19.4208 6.46071C19.1304 7.04146 18.9858 7.68417 18.9994 8.33333C18.9858 8.98249 19.1304 9.62521 19.4208 10.206C19.7112 10.7867 20.1385 11.288 20.666 11.6667M28.576 27.8767C29.3203 28.2184 30.1372 28.372 30.9548 28.324C31.7724 28.2761 32.5657 28.028 33.265 27.6016C33.9643 27.1752 34.5481 26.5836 34.9652 25.8788C35.3823 25.1739 35.6198 24.3774 35.6569 23.5592C35.694 22.741 35.5296 21.9263 35.1781 21.1865C34.8265 20.4468 34.2987 19.8047 33.6409 19.3168C32.9831 18.8289 32.2155 18.51 31.4056 18.3882C30.5957 18.2664 29.7682 18.3454 28.996 18.6183M5.66602 16.6667H28.9993V25C28.9993 27.6522 27.9458 30.1957 26.0704 32.0711C24.1951 33.9464 21.6515 35 18.9993 35H15.666C13.0139 35 10.4703 33.9464 8.59495 32.0711C6.71958 30.1957 5.66602 27.6522 5.66602 25V16.6667Z",
    stroke: "#353343",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.8bc171053710f7634fa9d55376e38469.svg";
export { ForwardRef as ReactComponent };